module.exports = __webpack_public_path__ + "img/taiwanHighSpeedRail-ok.31826866.jpg";